import RewriteStatusFilterType from 'crono-fe-common/types/enums/rewriteStatusFilterType';
import type { ContactsInStrategyOptionsForFilterBy } from './index';

export const getContactsInStrategyFilterLabel = (
  filter: ContactsInStrategyOptionsForFilterBy,
) => {
  switch (filter) {
    case RewriteStatusFilterType.REWRITE_IN_ERROR:
      return 'AI rewrite failed';
    case RewriteStatusFilterType.PERSONALIZED:
      return 'Rewritten with AI';
    case RewriteStatusFilterType.NOT_PERSONALIZED:
      return 'Not rewritten with AI';
    case 'warnings':
      return 'Warnings';
    case 'errors':
      return 'Errors';
  }
};

export const CONTACTS_IN_STRATEGY_FILTER_OPTIONS: ContactsInStrategyOptionsForFilterBy[] =
  [
    'warnings',
    'errors',
    RewriteStatusFilterType.PERSONALIZED,
    RewriteStatusFilterType.NOT_PERSONALIZED,
    RewriteStatusFilterType.REWRITE_IN_ERROR,
  ];

/** Reads the URL's comma-separated `filterBy`, dropping anything unknown. */
export const parseContactsInStrategyFilters = (
  value: string | null,
): ContactsInStrategyOptionsForFilterBy[] =>
  (value ?? '')
    .split(',')
    .filter((item): item is ContactsInStrategyOptionsForFilterBy =>
      CONTACTS_IN_STRATEGY_FILTER_OPTIONS.includes(
        item as ContactsInStrategyOptionsForFilterBy,
      ),
    );
